import { Routes } from '@angular/router';
import { PatrolLayoutComponent } from '../layouts/patrol/patrol.component';
import { ERole } from '../features/auth/enums/role.enum';
import { RoleGuard } from '../core/guards/role.guard';
import { AuthGuard } from '../core/guards/auth.guard';
import { PatrolAuthComponent } from '../features/patrol/pages/patrol-auth/patrol-auth.component';
import { PatrolSetupComponent } from '../features/patrol/pages/patrol-setup/patrol-setup.component';
import { PatrolDiscordComponent } from '../features/patrol/pages/patrol-discord/patrol-discord.component';
import { PatrolDiscordBotCallbackComponent } from '../features/patrol/pages/patrol-discord-bot-callback/patrol-discord-bot-callback.component';
import { PatrolRobloxComponent } from '../features/patrol/pages/patrol-roblox/patrol-roblox.component';
import { PatrolIntegrationRequestComponent } from '../features/patrol/pages/patrol-integration-request/patrol-integration-request.component';
import { PatrolProfileComponent } from '../features/patrol/pages/patrol-profile/patrol-profile.component';
import { patrolSourceEnabledGuard } from '../features/patrol/guards/patrol-source-enabled.guard';
import {
  layoutRoleChildGuard,
  layoutRoleGuard,
} from '../core/guards/layout-role.guard';

export const getPatrolRoutes = (): Routes => {
  return [
    {
      path: '',
      component: PatrolLayoutComponent,
      data: { layout: 'patrol', layoutRoles: [ERole.PATROL] },
      canActivate: [layoutRoleGuard],
      canActivateChild: [layoutRoleChildGuard],
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'setup',
        },
        {
          path: 'auth',
          component: PatrolAuthComponent,
        },
        {
          path: 'setup',
          canActivate: [AuthGuard, RoleGuard],
          component: PatrolSetupComponent,
          data: { roles: [ERole.PATROL] },
        },
        {
          path: 'integration',
          canActivate: [AuthGuard, RoleGuard],
          component: PatrolIntegrationRequestComponent,
          data: { roles: [ERole.PATROL] },
        },
        {
          path: 'discord/bot-callback',
          canActivate: [AuthGuard, RoleGuard],
          component: PatrolDiscordBotCallbackComponent,
          data: { roles: [ERole.PATROL] },
        },
        {
          path: 'discord',
          canActivate: [
            AuthGuard,
            RoleGuard,
            patrolSourceEnabledGuard('discord'),
          ],
          component: PatrolDiscordComponent,
          data: { roles: [ERole.PATROL] },
        },
        {
          path: 'roblox',
          canActivate: [
            AuthGuard,
            RoleGuard,
            patrolSourceEnabledGuard('roblox'),
          ],
          component: PatrolRobloxComponent,
          data: { roles: [ERole.PATROL] },
        },
        {
          path: 'profile',
          canActivate: [AuthGuard, RoleGuard],
          component: PatrolProfileComponent,
          data: { roles: [ERole.PATROL] },
        },
      ],
    },
    {
      path: '**',
      redirectTo: 'setup',
    },
  ];
};
